<template><img src="https://gadbulan.gob.ec/azuay/wp-content/themes/bulan01/images/logoFooter.png" alt="" /></template>

<script lang="ts" setup></script>
